import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import * as AnalisiListing from "./analisiListing/AnalisiListing";
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from "src/mtska-frontend-app-component";
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";

const Container = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const [reportVisible, setReportVisible] = useState(false);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const showFilters = true;
    const showKPI = true;

    const report = [
        {
            title: t('Listing'),
            icon: 'faRectangleHistoryCircleUser',
            pages: [
                {
                    title: t('Analisi'),
                    icon: 'faCalendar',
                    component: <AnalisiListing.default dataProviderName={dataProviderName} filters={filterModel} key={1} />
                }
            ]
        }
    ];

    return (
        <Box className="mtska-dashboard-container">
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Proposal status')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filterModel} />
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
        </Box>
    )
}

export default Container;